export const getSwcEnv = (pkg) => {
    const coreJsVersion = pkg.dependencies?.['core-js'] ??
        pkg.devDependencies?.['core-js'] ??
        pkg.peerDependencies?.['core-js'];
    if (!coreJsVersion)
        return { targets: 'defaults' };
    return {
        targets: 'defaults',
        coreJs: coreJsVersion,
        mode: 'usage',
        bugfixes: true,
    };
};
